// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__snYa7","fixed-header":"DefaultLayout_fixed-header__9eDPp"};